import { render, staticRenderFns } from "./FormQuestions.component.vue?vue&type=template&id=88552072"
import script from "./FormQuestions.component.vue?vue&type=script&lang=js"
export * from "./FormQuestions.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports